// state
const state = {
  alt: false
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {};

window.addEventListener("keydown", event => {
  if (event.key == "Alt") {
    state.alt = true;
  }
});

window.addEventListener("keyup", event => {
  if (event.key == "Alt") {
    state.alt = false;
  }
});

window.addEventListener("focus", () => {
  //workaround if we use alt tab on windows, cause we would receive keyup event
  state.alt = false;
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
